import * as React from "react";
import * as i18next from "i18next";
import * as Styled from "@tunnel-components/@sharded/@styled/styled";
import UsersActions from "@tunnel-components/@sharded/@widgets/users/actions/component";
import * as jwt_decode from "jwt-decode";
import * as Utils from "@Cyclope-Utils/index";
import * as Lodash from "lodash";
import * as Enums from "@tunnel-enums/index";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  // desturation
  const {
    /* onIsMail, onIsRoles, onIsLogin, isMail, isRoles, isLogin, */ onUpdateUser,
    onRemouveUser,
    usersArray,
    onChange,
    item,
    index,
  } = props;
  /**
   * @description : Retourne un objet de type any { utilisateur }
   * @const
   * @name data
   * @type { any }
   */
  const data: any =
    Utils.localStorageIsKeyExist() &&
    jwt_decode(Utils.localStorageIsKeyExist());

  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();

  /**
   * @description : retourne un boolean ( token )
   * @const
   * @name authorization
   * @type { boolean  }
   */

  const authorizationadd: any = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.ADMINISTRATIONUSERSUPDATED,
  ]);
  const authorizationremove: any = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.ADMINISTRATIONUSERSDELECTED,
  ]);

  /**
   * @description :
   * Retourne un boolean ,
   * vérifie si l'utilisateur connecter a
   * le role admin: ROLE_ADMIN
   * @const
   * @name dataAuth
   * @type { boolean }
   */
  const dataAuth: boolean = data && data.auth.includes("ROLE_ADMIN");
  /**
   * @description :
   * Retourne un boolean ,
   * vérifie si l'utilisateur connecter a
   * le role admin: ROLE_SUPER_ADMIN
   * @const
   * @name dataAuth
   * @type { boolean }
   */
  const dataAuthSuperAdmin: boolean =
    data && data.auth.includes("ROLE_SUPER_ADMIN");
  /**
   * @description :
   * Retourne un boolean ,
   * vérifie si l'utilisateur qui se trouve
   * dans la liste a
   * Le role admin: ROLE_ADMIN
   * @const
   * @name itemAuth
   * @type { boolean }
   */
  const itemAuth: boolean = item.authorities.includes("ROLE_ADMIN");
  /**
   * @description :
   * Retourne un boolean ,
   * vérifie si les utilisateurs ont le
   * Le role admin: ROLE_ADMIN
   * @const
   * @name rigthToRemoveAdmin
   * @type { boolean }
   */
  const rigthToRemoveAdmin: boolean = !Lodash.isEqual(dataAuth, itemAuth);
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */

  return (
    <section className="arrayContent">
      <span className="arraysContentSpanAuto" style={{ width: "2.5%" }}>
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p style={{ cursor: "default", width: "20px" }}>{index + 1}</p>
          </div>
        </div>
      </span>
      <span className="arraysContentSpanAuto" style={{ width: "17%" }}>
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p style={{ cursor: "default" }}>{item.login}</p>
          </div>
          <Styled.BreadBoxContainer
            className={
              !!item && !!item.login && item.login.length > 12
                ? "isVisible"
                : ""
            }
            isVisible={!!item && !!item.login && item.login.length > 12}
            style={{ width: "auto", top: "11px", color: "black" }}
          >
            {item.login}
          </Styled.BreadBoxContainer>
        </div>
      </span>
      <span className="arraysContentSpanAuto" style={{ width: "15%" }}>
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p style={{ cursor: "default" }}>{item.lastName}</p>
          </div>
        </div>
      </span>
      <span className="arraysContentSpanAuto" style={{ width: "15%" }}>
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p style={{ cursor: "default" }}>{item.firstName}</p>
          </div>
        </div>
      </span>
      <span className="arraysContentSpanAuto" style={{ width: "22%" }}>
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p style={{ cursor: "default" }}>{item.email}</p>
          </div>
          <Styled.BreadBoxContainer
            className={
              !!item && !!item.email && item.email.length > 12
                ? "isVisible"
                : ""
            }
            isVisible={!!item && !!item.email && item.email.length > 12}
            style={{ width: "auto", top: "11px", color: "black" }}
          >
            {item.email}
          </Styled.BreadBoxContainer>
        </div>
      </span>
      <span className="arraysContentSpanAuto" style={{ width: "20%" }}>
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p style={{ cursor: "default" }}>
              {item.authorities.map(
                (role: string, indexAuthorities: number) => (
                  <b key={indexAuthorities} style={{ color: "#88898a" }}>
                    {" "}
                    {i18next.t(`${role}`)} {"  "}{" "}
                  </b>
                )
              )}
            </p>
          </div>
          <Styled.BreadBoxContainer
            className={
              !!item && !!item.authorities && item.authorities.length > 1
                ? "isVisible"
                : ""
            }
            isVisible={
              !!item && !!item.authorities && item.authorities.length > 1
            }
            style={{ width: "auto", top: "11px", color: "#88898a" }}
          >
            {item.authorities.map((role: string, indexAuthorities: number) => (
              <b key={indexAuthorities} style={{ color: "#88898a" }}>
                {" "}
                {i18next.t(`${role}`)} {"  "}{" "}
              </b>
            ))}
          </Styled.BreadBoxContainer>
        </div>
      </span>
      {!item.authorities.includes("ROLE_SUPER_ADMIN") && (
        <span
          className="arraysContentSpanAuto"
          style={{ width: "8.5%" }}
          onMouseEnter={
            authorizationadd || authorizationremove ? onChange : "undefined"
          }
          onMouseLeave={
            authorizationadd || authorizationremove ? onChange : "undefined"
          }
        >
          <div className="arraysContentContenair">
            <div className="arrayContentInfos">
              {(authorizationadd || authorizationremove) && (
                <p className="arraysAction" style={{ cursor: "pointer" }}>
                  Action
                </p>
              )}
              {!authorizationadd && !authorizationremove && (
                <p
                  className="arraysAction"
                  style={{ cursor: "default", background: "#f3f3f3" }}
                >
                  Action
                </p>
              )}
            </div>
            <Styled.BreadBoxContainer
              isVisible={usersArray && rigthToRemoveAdmin}
              style={{
                right: "80px",
                width: "auto",
                top: "-1px",
                minHeight: "50px",
              }}
            >
              <UsersActions
                onUpdateUser={onUpdateUser}
                item={item}
                identificationUser={item.id}
                onRemouveUser={onRemouveUser}
              />
            </Styled.BreadBoxContainer>
            <Styled.BreadBoxContainer
              isVisible={
                usersArray && !Lodash.isEqual(dataAuthSuperAdmin, false)
              }
              style={{
                right: "80px",
                width: "auto",
                top: "-1px",
                minHeight: "50px",
              }}
            >
              <UsersActions
                onUpdateUser={onUpdateUser}
                item={item}
                identificationUser={item.id}
                onRemouveUser={onRemouveUser}
              />
            </Styled.BreadBoxContainer>
          </div>
        </span>
      )}

      {item.authorities.includes("ROLE_SUPER_ADMIN") && (
        <span className="arraysContentSpanAuto" style={{ width: "8.5%" }}>
          <div className="arraysContentContenair">
            <div className="arrayContentInfos">
              <p style={{ cursor: "default", height: "33px" }} />
            </div>
          </div>
        </span>
      )}
    </section>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  fill?: any;
  onUpdateUser?: any;
  onRemouveUser?: any;
  usersArray?: any;
  onChange?: any;
  item?: any;
  index?: any;
  onIsMail?: any;
  onIsRoles?: any;
  onIsLogin?: any;
  isMail?: boolean;
  isRoles?: boolean;
  isLogin?: boolean;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/users/lists/component.tsx